import React from 'react';

import { privacyPolicy } from '../../content/legal';
import LegalPage, { LegalContent } from '../LegalPage/LegalPage';

// The Privacy Policy, rendered from the copy held in src/content/legal.
const PrivacyPolicyPage = () => <LegalPage doc={privacyPolicy} currentPage="PrivacyPolicyPage" />;

// The same document without the page chrome, for use inside modals.
const PrivacyPolicyContent = () => <LegalContent doc={privacyPolicy} />;

export { PrivacyPolicyContent };

export default PrivacyPolicyPage;
